import { render, staticRenderFns } from "./VideoBar.vue?vue&type=template&id=b4e296a6&scoped=true"
import script from "./VideoBar.vue?vue&type=script&lang=js"
export * from "./VideoBar.vue?vue&type=script&lang=js"
import style0 from "./VideoBar.vue?vue&type=style&index=0&id=b4e296a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e296a6",
  null
  
)

export default component.exports